import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';

/**
 * Formatta una data (stringa 'YYYY-MM-DD' o Date) nel giorno localizzato per la
 * lingua attiva, es. "sab 12 dicembre 2026" (it), "Sat 12 December 2026" (en).
 * Usa ember-intl (Intl.DateTimeFormat del browser) → multilingua senza dipendere
 * dal locale globale di moment.
 */
export default class FormatDayLocaleHelper extends Helper {
  @service intl;

  compute([date], { weekday = 'short' } = {}) {
    if (!date) {
      return null;
    }
    // 'YYYY-MM-DD' interpretata a mezzogiorno locale per evitare shift di fuso.
    const d = typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)
      ? new Date(`${date}T12:00:00`)
      : new Date(date);
    if (isNaN(d.getTime())) {
      return date;
    }
    const opts = { day: '2-digit', month: 'long', year: 'numeric' };
    if (weekday) {
      opts.weekday = weekday;
    }
    return this.intl.formatDate(d, opts);
  }
}
